/** Small deterministic PRNG, so a tag's torn edge is the same on every render. */
function rng(seed: number): () => number {
  let a = seed * 2654435761
  return () => {
    a = (a + 0x6d2b79f5) | 0
    let t = Math.imul(a ^ (a >>> 15), 1 | a)
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296
  }
}

/**
 * The outline of a torn paper note, like the "RM" slip on the cash plaque:
 * straight enough to read as a rectangle, ragged enough to read as paper.
 */
export function tornPaper(w: number, h: number, seed: number): string {
  const r = rng(seed + 1)
  const j = (amp: number): number => (r() - 0.5) * 2 * amp
  const pts: string[] = []
  const step = 12
  for (let x = 0; x <= w; x += step) pts.push(`${x},${4 + j(3)}`)
  for (let y = step; y <= h; y += step) pts.push(`${w - 4 + j(3)},${y}`)
  for (let x = w - step; x >= 0; x -= step) pts.push(`${x},${h - 4 + j(3)}`)
  for (let y = h - step; y > 0; y -= step) pts.push(`${4 + j(3)},${y}`)
  return `M${pts.join('L')}Z`
}
